<script>
  import session from '../../../lib/session';

  import { onMount } from 'svelte';
  import { MDCDataTable } from '@material/data-table';
  import { t9n } from '../../../lib/translate';
  import { TS } from '../../../config/translation-keys.js';

  import TableHeader from './TableHeader.svelte';
  import TableBody from './TableBody.svelte';

  // component options  ------------------------------------------------------ //

  export let headers;
  export let table_data;
  export let searched;
  export let current_page;
  export let number_of_pages;
  export let current_chip;
  export let current_group;
  export let filters;
  export let show_filters;
  export let hide_cancelled;

  // internal variables  ------------------------------------------------------ //

  let data_table;

  // translated strings ------------------------------------------------------ //

  let button_prev;
  let button_next;

  // utility functions -------------------------------------------------------- //

  const init_table = () => {
    data_table = new MDCDataTable(document.querySelector('.mdc-data-table'));
  };

  const prev_page = async () => {
    if (current_page !== 1) {
      current_page--;
    }
    await window.get_data_from_api(current_group);
  };

  const next_page = async () => {
    if (current_page !== number_of_pages) {
      current_page++;
    }
    await window.get_data_from_api(current_group);
  };

  const translate_texts = () => {
    button_prev = t9n(TS.TABLE_BUTTON_PREV);
    button_next = t9n(TS.TABLE_BUTTON_NEXT);
  };

  // reactive functions ------------------------------------------------------- //

  $: if (!!$session) translate_texts();

  onMount(init_table);
</script>


<div
  class='mdc-data-table table-min-height'
  class:slide-down={current_chip === 3}>
  <table class='mdc-data-table__table fade-in' aria-label='Orders' width='600'>
    <TableHeader
      headers={headers}
      current_group={current_group} />

    <TableBody
      searched={searched}
      table_data={table_data}
      current_chip={current_chip}
      current_page={current_page}
      number_of_pages={number_of_pages}
      headers={headers}
      filters={filters}
      hide={hide_cancelled}
      show_filters={show_filters}/>

  </table>

</div>

<div style='display: flex; justify-content: flex-end; margin-top: 30px;'>

  {#if number_of_pages !== 0}
    {#if current_page !== 1}
      <button
        on:click={prev_page}
        class='mdc-button mdc-button--outlined margin-5'>
        <span class='mdc-button__ripple' />
        {button_prev}
      </button>
    {/if}

    {#if current_page !== number_of_pages}
      <button
        on:click={next_page}
        style='margin-left: 5px;'
        class='mdc-button mdc-button--unelevated margin-5'>
        <span class='mdc-button__ripple' />
        {button_next}
      </button>
    {/if}
  {/if}
</div>

<style>

    .table-min-height {
        min-height: 110px;
    }

    .mdc-data-table__content tr {
        cursor: pointer;
    }

    .slide-down {
        animation: move-down 0.1s linear;
        opacity: 1;
        overflow: hidden;
    }


    @keyframes move-down {
        0% {
            opacity: 1;
            -webkit-transform: translateY(-10px);
        }
        100% {
            opacity: 1;
            -webkit-transform: translateY(0px);
        }
    }

    /* Mobile Mode
        *******************************************************/
    @media (max-width: 768px) {
        table {
            width: 100%;
        }

        td.mdc-data-table__cell i {
            margin-left: 50%;
        }
    }
</style>
